exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buildPortfolio__main {\n  background-color: #ffffff;\n  margin-top: -145px;\n  position: relative;\n  min-height: 655px;\n  margin-left: -15px;\n  padding: 5px 15px;\n  width: calc(100% + 30px);\n  border-radius: 10px 10px 0 0;\n  z-index: 1000; }\n  .buildPortfolio__main .tab-content {\n    padding-top: 20px; }\n    .buildPortfolio__main .tab-content_failed {\n      text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create_portfolio_by_Advisor/CreataPortfolioByAnalysis.style.scss
// module id = 1662
// module chunks = 0